import { render, staticRenderFns } from "./InsertWheicle.vue?vue&type=template&id=72daed70&"
import script from "./InsertWheicle.vue?vue&type=script&lang=js&"
export * from "./InsertWheicle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports